import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementDefaultFolderTemplatesManager } from '@inpart-io/padme-iap';
import { type IDefaultFolderTemplate } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const AGREEMENT_DEFAULT_FOLDER_TEMPLATE_MODULE = 'agreementdefaultfoldertemplates';

const dataObjectModule = getDataObjectsModule<IDefaultFolderTemplate>(agreementDefaultFolderTemplatesManager, 3);
const searchModule = getSearchModule<IDefaultFolderTemplate>(agreementDefaultFolderTemplatesManager);

const agreementDefaultFolderTemplateModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(AGREEMENT_DEFAULT_FOLDER_TEMPLATE_MODULE, agreementDefaultFolderTemplateModuleInstance);

export { AGREEMENT_DEFAULT_FOLDER_TEMPLATE_MODULE };
